import React from "react";
import {useLocalization} from "./i18n";
import {B2Site} from "./data/client.gen";
import {BoxPackagePrice} from "./data/sites";

export function notBlank(value: string|undefined|null) {
	return value !== undefined && value !== null && value.length > 0;
}

export function isBlank(value: string|undefined|null) {
	return value === undefined || value === null || value.length === 0;
}

export function notNull(value: string|number|undefined|null) {
	return value !== undefined && value !== null;
}

export function DisplayCurrency({amount}: { amount: number }) {
	const {language} = useLocalization();
	const format = new Intl.NumberFormat(language, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
	return (
		<span>{format.format(amount)}</span>
	);
}

export function formatInteger(value: number) {
	const {language} = useLocalization();
	const format = new Intl.NumberFormat(language, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
	return format.format(value);
}

export function getEnvironment(): 'development'|'production'|'local' {
	const {hostname} = location;
	if (hostname.indexOf('localhost') > -1) return 'local';
	else if (hostname.indexOf('-dev') > -1) return 'development';
	else return 'production';
}

export function getCubeCenterBaseUrl() {
	switch (getEnvironment()) {
		case 'production':
			return 'https://api.cubeadmin.center';
		case 'development':
			return 'https://api-dev.cubeadmin.center';
		case 'local':
			return 'http://localhost:7000';
	}
}

export function isEmail(email: string|undefined): boolean {
	if(!email) return false;
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email.toLowerCase());
}

export function computePackages(boxes: B2Site['boxes']) {
	return boxes.length > 0
		? Object.entries(boxes[0].packagePrice as BoxPackagePrice).map(([units, price]) => ({ units: parseInt(units), price }))
		: [];
}
